<template>
  <div>
    <div class="py-10 px-5 max-w-4xl mx-auto">
      <p
        class="text-2xl font-bold pb-3 mb-10 text-center border-b border-gray-300"
      >
        CSSNLP 2020 论坛简介
      </p>
      <div class="mt-5">
        <div class="w-full border-b border-gray-300 py-5">
          <ul class="list-reset flex flex-wrap">
            <li
              class="-mb-px mr-1"
              v-for="(forum, forum_id) in forums"
              :key="forum.name"
            >
              <a
                class="cursor-pointer bg-white inline-block rounded py-2 px-4 text-blue-dark font-semibold"
                v-bind:class="{
                  'bg-gray-200': name == forum_id,
                  'text-blue-800': name == forum_id,
                  'shadow-inner': name == forum_id,
                  'hover:text-blue-800': name != forum_id,
                }"
                @click="name = forum_id"
                >{{ forum.name }}</a
              >
            </li>
          </ul>
        </div>
        <div class="text-left mt-5">
          <div v-if="presents.length > 0">
            <div v-for="(present, idx) in presents" :key="present.title">
              <div v-if="present.bio" class="border-b py-10">
                <p class="py-1 text-xl text-blue-800 font-bold">
                  <span class="font-bold">{{ forums[name].name }} </span>
                  <span class="font-bold">{{ '#' + (idx + 1) }} </span>
                  <span class="font-bold text-gray-900 ml-1">{{
                    present.title
                  }}</span>
                </p>
                <img
                  class="rounded my-5 h-48 shadow-md hover:shadow-lg transition-all duration-300"
                  :src="present.img_link"
                  v-if="present.img_link"
                  alt=""
                />
                <div>
                  <p class="font-bold">
                    <span class="font-bold">讲者：</span>
                    <span>{{ present.presenter }}</span>
                  </p>
                  <p class="">
                    <span class="font-bold">时间：</span>
                    <span>{{ present.time }}</span>
                  </p>
                </div>
                <p class="mt-2">
                  <span class="font-bold">摘要：</span>
                  <span>{{ present.abstract }}</span>
                </p>
                <p class="mt-2">
                  <span class="font-bold">简介：</span>
                  <span>{{ present.bio }}</span>
                </p>
              </div>
              <div v-else class="mb-2">
                <p class="py-1 text-blue-800 font-bold text-sm">
                  <span class="font-bold">{{ '#' + (idx + 1) }} </span>
                  <span class="font-bold text-gray-900 ml-1">{{
                    present.title
                  }}</span>
                </p>
                <div class="flex text-xs ml-8">
                  <p class="font-bold">
                    <span class="pr-2"
                      ><font-awesome-icon :icon="['far', 'user']"
                    /></span>
                    <span>{{ present.presenter }}</span>
                  </p>
                  <p class="ml-4">
                    <span class="pr-2"
                      ><font-awesome-icon :icon="['far', 'clock']"
                    /></span>
                    <span>{{ present.time }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p class="ml-4 font-bold">敬请期待。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>>

<script>
export default {
  metaInfo: {
    title: "论坛"
  },
  props: {
    name: {
      type: String,
      default: 'special',
    },
  },
  data() {
    return {
      forums: {
        special: {
          name: '特邀报告',
          presents: [
            {
              presenter: '车万翔',
              title: '基于小样本学习的自然语言处理',
              time: '2020年12月26日09:00-10:00',
              img_link: require('@/assets/images/cwx.jpg'),
              abstract: '小样本学习（Few-shotLearning）希望计算机能像人一样只用几个样本学习新的任务，近年来已成为机器学习社区的热点研究问题，并被看作是让机器智能接近人类智能的关键方向。很多自然语言处理任务由于需要频繁适应新领域、新需求，而新的领域往往数据不足，所以亟需小样本学习技术。我们分别探索了小样本文本序列标注以及小样本多标签文本分类问题。此外，现在自然语言处理中的小样本学习缺乏一个统一的、能反映真实世界任务挑战的基准测试，为此我们标注了一个全新的小样本数据集FewJoint，并组织了SMP2020技术评测，希望能以此推动自然语言处理中小样本学习研究的进展。',
              bio:
                '车万翔博士，哈尔滨工业大学计算机学院长聘教授、博士生导师，社会计算与信息检索中心副主任。教育部青年长江学者，黑龙江省“龙江学者”青年学者，斯坦福大学访问学者，2019年入选黑龙江省首批“头雁计划”团队成员。现任中国中文信息学会计算语言学专业委员会副主任、秘书长；中国计算机学会高级会员、曾任YOCSEF哈尔滨主席（2016-2017年度）。在ACL、EMNLP、AAAI、IJCAI等国内外高水平期刊和会议上发表学术论文50余篇，其中AAAI2013年的文章获得了最佳论文提名奖，论文累计被引用3,900余次（GoogleScholar数据），H-index值为34。出版教材2部，译著2部。目前承担2030“新一代人工智能”重大项目课题、国家自然科学基金等多项科研项目。负责研发的语言技术平台（LTP）已被600余家单位共享，提供的在线“语言云”服务已有用户1万余人，并授权给百度、腾讯、华为等公司使用。2018、2019连续两年获CoNLL国际评测第1名。2020年获黑龙江省青年科技奖；2015、2016连续两年获GoogleFocusedResearchAward（谷歌专注研究奖）；2016年，获黑龙江省科技进步一等奖（排名第2）；2012年，获黑龙江省技术发明奖二等奖（排名第2）；2010年获中国中文信息学会“钱伟长”中文信息处理科学技术奖一等奖（排名第2）、首届汉王青年创新奖（个人）等多项奖励。2017年，所主讲的MOOC课程《高级语言程序设计（Python）》获国家精品在线开放课程。',
            },
            {
              presenter: '邱锡鹏',
              title: '玩不动预训练，我们能做什么？',
              time: '2020年10月27日09:00-10:00',
              img_link: require('@/assets/images/qxp.png'),
              abstract: '目前预训练模型在自然语言处理领域取得了广泛的成功。如果没有资源训练预训练模型，我们还能做这些什么？本报告主要围绕如何提高预训练模型的应用效果进行展开，包括精调、多步迁移、增加鲁棒性以及任务转换等方法，以便充分利用预训练模型的特点来进一步提高下游任务效果。',
              bio:
                '邱锡鹏，复旦大学计算机科学技术学院教授，博士生导师。于复旦大学获得理学学士和博士学位。主要从事自然语言处理、深度学习等方向的研究，发表CCF A/B类论文70余篇，获得ACL 2017杰出论文奖（CCF A类）、CCL 2019最佳论文奖。出版开源专著《神经网络与深度学习》，Github关注人数1.3万，豆瓣评分9.5分。获得国家优秀青年科学基金、首届中国科协青年人才托举工程项目、钱伟长中文信息处理科学技术奖青年创新一等奖、Aminer"2020年度AI 2000人工智能全球最具影响力提名学者"等。培养学生曾获中国中文信息学会优博、中国人工智能学会优博、微软学者、微软学者提名、百度奖学金、上海市优博提名等。',
            },
          ],
        },
        advance: {
          name: '前沿主题研讨',
          presents: [
            {
              presenter: '姚远',
              title: '面向复杂文本场景的知识获取',
              time: '2020年10月26日14:00-15:00',
              img_link: require('@/assets/images/yy.jpg'),
              abstract:
                '知识获取是自然语言处理领域中的重要任务，旨在从文本中抽取关于实体的结构化知识，构建大规模知识图谱。在这次报告中，讲者将梳理各类复杂文本场景下知识获取的研究进展与典型问题。',
              bio:
                '姚远，清华大学计算机系三年级在读博士生，导师为刘知远副教授。研究兴趣为复杂场景下的关系抽取，包括文档级关系抽取、开放关系抽取和少次关系抽取。',
            },
            {
              presenter: '覃立波',
              title: '初探迁移学习在任务型对话系统中的应用',
              time: '2020年10月26日15:00-16:00',
              img_link: require('@/assets/images/tlb.png'),
              abstract:
                '如果说自然语言处理可被誉为“人工智能皇冠上的明珠”，那么对话系统就是“自然语言处理皇冠上的明珠”。其中以苹果SIRI、Google Assistant为代表的任务型对话系统尤为学术界和产业界所关注。然而，构建一个任务型对话系统依赖于大规模的标注数据，这为系统如何快速迁移到新的领域、新的语言和新的任务都带来了极大的挑战。本报告重点介绍在跨领域、跨语言和跨任务的任务型对话系统中所做的一些研究工作。',
              bio:
                '哈尔滨工业大学社会计算与信息检索研究中心在读博士生，导师车万翔教授。主要研究方向为任务型对话系统，以第一作者曾在ACL、EMNLP、AAAI、IJCAI等顶级会议发表论文多篇。曾获博士百度奖学金、字节跳动奖学金（中国10人）等荣誉。',
            },
          ],
        },
        phd: {
          name: '博士生论坛',
          presents: [
            {
              presenter: '陈修意',
              title: '知识选择与对话生成',
              time: '2020年10月27日14:00-14:40',
              img_link: require('@/assets/images/cxy.png'),
              abstract:
                '基于Seq2Seq的对话生成模型倾向于产生通用回复，因此在对话系统中引入外部知识生成有信息量的回复成为当前的研究主流。在这个报告中，我们主要介绍用于知识对话生成的知识选择：即首先根据上下文选择知识句子，然后基于知识生成对话回复。重点地，我们介绍了基于隐变量模型的知识选择以及我们的改进。最后，我们将讨论知识对话生成的一点思考。',
              bio:
                '硕博连读第四年，师从徐波研究员。硕士期间研究鸡尾酒会问题，获国家奖学金。博士研究方向为对话系统，在ACL、EMNLP、COLING上发表过相关论文。',
            },
            {
              presenter: '隋典伯',
              title: '从乱序到有序再到无序:实体关系联合抽取中的三元组顺序问题',
              time: '2020年10月27日14:40-15:20',
              img_link: require('@/assets/images/sdb.jpeg'),
              abstract:
                '实体和关系联合抽取任务的目标是将给定自然语言句子中所提及的所有三元组抽取出来。Seq2Seq模型是很多实体和关系联合抽取系统的基础，在这个报告中，我将介绍一个全新的角度，将实体和关系联合抽取任务建模成一个Seq2Set问题。从这一角度出发，可以解决之前基于Seq2Seq的实体和关系联合中的暴露偏置问题，三元组顺序问题。为了解决Seq2Set问题，我将介绍基于非自回归解码器的集合元素生成模块和基于二分图匹配的训练损失函数。相关论文可见https://arxiv.org/pdf/2011.01675.pdf。',
              bio:
                '中科院自动化所在读，博士四年级，导师是赵军研究员。博士期间的主要研究方向是实体抽取和关系抽取，以第一作者在EMNLP发表两篇文章。',
            },
            {
              presenter: '王本友',
              title: 'On Position Embeddings',
              time: '2020年10月27日15:20-16:00',
              img_link: require('@/assets/images/wby.png'),
              abstract:
                'Transformer广泛使用在NLP任务（特别是预训练模型），甚至开始用到CV领域崭露头角。Transformer其结构除去位置编码将不能建模输入的顺序，所以位置编码及其重要。目前很多预训练模型都用不同的位置编码（比如完全可学习的位置编码，三角函数式固定的位置编码，相对位置编码），经验上都表现不错，但是缺少一个统一的框架来理解和评价这些位置编码。我们最新的工作形式化位置编码的一些原则上的属性（平移不变，单调和对称性），并评估存在的位置编码多少程度上满足这些属性，最后定量评估这些属性如何受益/损害下游任务。我们发现完全可学习的位置编码在整句分类场景效果不错，得益于其能够灵活处理CLS特殊token和正常的位置；相对位置编码在span prediction上效果更佳。',
              bio:
                '王本友，意大利帕多瓦大学博士生，欧盟玛丽居里研究员。在天津大学受宋大为和张鹏教授指导下获得硕士学位，曾在丹麦哥本哈根大学，加拿大蒙特利尔大学，荷兰阿姆斯特丹大学，华为诺亚方舟实验室，中科院理论物理所，社科院语言所交流访问；多次受邀在MILA，头条，腾讯，华为，阿里等研究所和企业做主题报告。在工业应用方面，他2017年开始曾在腾讯全职工作，作为主要算法设计人员，在腾讯云上从零搭建了稳健的智能客服系统，服务中国银行/云南省旅游局等头部客户；并与腾讯同事合写的《推荐系统与深度学习》由清华大学出版社出版。在相对较短的学术生涯，他致力于构建更加鲁棒和智能的自然语言处理系统，兼顾技术合理性和语言学动机。迄今他和他的合作者一起获得了国际信息检索顶级会议SIGIR 2017最佳论文提名奖和国际自然语言处理顶级会议NAACL 2019最佳可解释论文，发表了包括国际顶级会议ICLR/SIGIR/WWW/NAACL/AAAI/IJCAI/CIKM等20余篇。',
            },
          ],
        },
        coling: {
          name: 'COLING论文报告',
          presents: [
            {
              time: '12月26日10:15-10:30',
              presenter: '司程磊',
              online: '线上',
              title: 'CharBERT: Character aware Pretrained Language Model ',
            },
            {
              time: '12月26日10:30-10:45',
              presenter: '范智昊',
              online: '线下',
              title:
                'An Enhanced Knowledge Injection Model for Commonsense Generation',
            },
            {
              time: '12月26日10:45-11:00',
              presenter: '朱桐',
              online: '线上',
              title:
                'Towards Accurate and Consistent Evaluation: A Dataset for Distantly-Supervised Relation Extraction',
            },
            {
              time: '12月26日11:00-11:15',
              presenter: '章华奥',
              online: '线上',
              title: 'Token Drop mechanisim for Neural Machine Translation',
            },
            {
              time: '12月26日11:15-11:30',
              presenter: '蔡鸿杰',
              online: '线上',
              title:
                'Aspect-Category based Sentiment Analysis with Hierarchical Graph Convolutional Network',
            },
            {
              time: '12月26日11:30-11:45',
              presenter: '杨云翊',
              online: '线上',
              title: 'Constituency Lattice Encoding for Aspect Term Extraction',
            },
            {
              time: '12月26日11:45-12:00',
              presenter: '左新宇',
              online: '线下',
              title:
                'KnowDis: Knowledge Enhanced Data Augmentation for Event Causality Detection via Distant Supervision',
            },
            {
              time: '12月26日16:15-16:30',
              presenter: '郁俊杰',
              online: '线上',
              title:
                'Improving Relation Extraction with Relational Paraphrase Sentences',
            },
            {
              time: '12月26日16:30-16:45',
              presenter: '陈蕾',
              online: '线下',
              title:
                'Modeling Evolution of Message Interaction for Rumor Resolution',
            },
            {
              time: '12月26日16:45-17:00',
              presenter: '周昆',
              online: '线下',
              title: 'Towards Topic-Guided Conversational Recommender System',
            },
            {
              time: '12月26日17:00-17:15',
              presenter: '黄培馨',
              online: '线下',
              title: 'Joint Event Extraction with Hierarchical Policy Network',
            },
            {
              time: '12月26日17:15-17:30',
              presenter: '孙天祥',
              online: '线上',
              title: 'CoLAKE: Contextualized Language and Knowledge Embedding',
            },
            {
              time: '12月26日17:30-17:45',
              presenter: '董博文',
              online: '线下',
              title:
                'Meta-Information Guided Meta-Learning for Few-Shot Relation Classification',
            },
            {
              time: '12月26日17:45-18:00',
              presenter: '李明浩',
              online: '线下',
              title:
                'DocBank: A Benchmark Dataset for Document Layout Analysis',
            },
          ],
        },
        emnlp: {
          name: 'EMNLP论文报告',
          presents: [
            {
              time: '12月27日10:15-10:30',
              presenter: '耿秀波',
              online: '线下',
              title:
                'Towards Interpretable Reasoning over Paragraph Effects in Situation',
            },
            {
              time: '12月27日10:30-10:45',
              presenter: '谷舒豪',
              online: '线下',
              title:
                'Token-level Adaptive Training for Neural Machine Translation',
            },
            {
              time: '12月27日10:45-11:00',
              presenter: '钟宛君',
              online: '线下',
              title: 'Neural Deepfake Detection with Factual Structure of Text',
            },
            {
              time: '12月27日11:00-11:15',
              presenter: '金致静',
              online: '线上',
              title:
                'Tasty Burgers, Soggy Fries: Probing Robustness in ABSA Models',
            },
            {
              time: '12月27日11:15-11:30',
              presenter: '李林阳',
              online: '线上',
              title: 'BERTATTACK adversarial attack against bert using bert',
            },
            {
              time: '12月27日11:30-11:45',
              presenter: '岂凡超',
              online: '线上',
              title: 'WantWords: An Online Reverse Dictionary System',
            },
            {
              time: '12月27日16:15-16:30',
              presenter: '李健铨',
              online: '线下',
              title:
                'BERT-EMD: Many-to-Many Layer Mapping for BERT Compression with Earth Mover’s Distance ',
            },
            {
              time: '12月27日16:30-16:45',
              presenter: '李东方',
              online: '线上',
              title:
                'Towards medical machine reading comprehension with structural knowledge and plain text',
            },
            {
              time: '12月27日16:45-17:00',
              presenter: '汪贻俊',
              online: '线上',
              title:
                'Pre-training Entity Relation Encoder with Intra-span and Inter-span Information',
            },
            {
              time: '12月27日17:00-17:15',
              presenter: '王瑞泽',
              online: '线上',
              title:
                'Leveraging Declarative Knowledge in Text and First-Order Logic for Fine-Grained Propaganda Detection',
            },
            {
              time: '12月27日17:15-17:30',
              presenter: '陈俊帆',
              online: '线下',
              title:
                'Parallel Interactive Networks for Multi-Domain Dialogue State Generation',
            },
            {
              time: '12月27日17:30-17:45',
              presenter: '白雪峰',
              online: '线上',
              title: 'Online Back-Parsing for AMR-to-Text Generation',
            },
          ],
        },
      },
    };
  },
  computed: {
    presents: function () {
      if (this.forums[this.name]) {
        return this.forums[this.name].presents;
      } else {
        return [];
      }
    },
  },
  watch: {
    name: function () {
      this.$router.push({
        name: 'Forum',
        params: { name: this.name },
      });
    },
  },
};
</script>
